// "index" is not a unique OCaml module, so... rename and re-export it is
export { default } from './IndexLayout';


// WEBPACK FOOTER //
// ./src/layouts/index.js